import React from "react";
import { ArrowRight, TrendingUp } from "lucide-react";

const Hero = () => {
  return (
    <section 
      className="hero-section relative overflow-hidden"
      style={{
        backgroundImage: 'linear-gradient(rgba(252, 202, 199, 0.9), rgba(253, 215, 197, 0.85)), url("https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxBSSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzU5OTMxOTE1fDA&ixlib=rb-4.1.0&q=85")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="hero-content relative z-10">
        {/* Announcement */}
        <div className="hero-announcement">
          <TrendingUp size={12} style={{ color: 'var(--accent-orange-400)' }} />
          <span>NEW LAUNCH: Professional AI Agent System for Modern Businesses</span>
        </div>
        
        <h1 className="heading-hero mb-4">
          Transform Your Business with 
          <br />
          <span style={{ color: 'var(--accent-orange-400)' }}>AI Agent Automation</span>
        </h1>
        
        <p className="body-large mb-6" style={{ 
          maxWidth: '650px', 
          margin: '0 auto 1.5rem',
          color: 'var(--text-primary)',
          fontWeight: '500'
        }}>
          Automate lead generation, qualification, demos, contracts, project management, and support with our 6-agent AI system.
          <strong> Built on proven automation methodologies.</strong>
        </p>

        {/* Value Proposition */}
        <div className="p-6 rounded-lg mb-8 max-w-2xl mx-auto" style={{ 
          background: 'rgba(59, 130, 246, 0.1)', 
          border: '2px solid rgba(59, 130, 246, 0.2)' 
        }}>
          <div className="flex items-center gap-3 mb-3">
            <TrendingUp size={24} style={{ color: 'var(--accent-blue-400)' }} />
            <div className="heading-3" style={{ color: 'var(--accent-blue-400)' }}>
              Complete AI Agent System for Your Business
            </div>
          </div>
          <div className="body-medium">
            Our 6-agent AI system automates your entire customer journey from lead generation to ongoing support. Built with low-code tools and AI integration for rapid deployment.
          </div>
        </div>

        {/* Primary CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
          <button className="btn-primary flex items-center gap-2 hover-scale text-lg px-8 py-4">
            Get Started with AI Automation
            <ArrowRight size={18} />
          </button>
          <div className="text-center">
            <div className="body-small mb-1" style={{ color: 'var(--text-muted)' }}>
              Schedule a consultation to learn more
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto mb-8">
          <div className="text-center p-4 rounded-lg" style={{ background: 'rgba(255, 255, 255, 0.6)' }}>
            <div className="heading-1 mb-1" style={{ color: 'var(--accent-orange-400)' }}>6 Agents</div>
            <div className="body-small">Comprehensive AI System</div>
          </div>
          <div className="text-center p-4 rounded-lg" style={{ background: 'rgba(255, 255, 255, 0.6)' }}>
            <div className="heading-1 mb-1" style={{ color: 'var(--accent-blue-400)' }}>30 Days</div>
            <div className="body-small">Implementation Timeline</div>
          </div>
          <div className="text-center p-4 rounded-lg" style={{ background: 'rgba(255, 255, 255, 0.6)' }}>
            <div className="heading-1 mb-1" style={{ color: 'var(--accent-purple-400)' }}>Low-Code</div>
            <div className="body-small">Fast Setup & Deployment</div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="text-center">
          <div className="body-small mb-2" style={{ color: 'var(--text-muted)' }}>
            Built with industry-standard tools and best practices
          </div>
          <div className="body-small font-semibold" style={{ color: 'var(--accent-green-200)' }}>
            ✓ Satisfaction Guarantee ✓ Professional Setup ✓ Ongoing Support
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;